<template>
  <BbPopup v-model="isOpened" :showCloseIcon="true" contentClass="create-collection-dialog">
    <template #popup-header>
      <div class="shared-collection-header">
        <div class="image-header">
          <div class="image-container">
            <img v-if="thumbUrl" :src="thumbUrl" alt="thumb" />
            <div v-else class="default-thumb" />
          </div>
        </div>
        <div class="collection-details">
          <span class="collection-title">{{ currentCollection?.collectionName || '' }}</span>
          <span class="collection-description">{{ currentCollection?.collectionDescription || '' }}</span>
        </div>
      </div>
    </template>
    <div class="share-link-actions">
      <BbInput v-model="sharedLink" placeholder="Here will be the link" />
      <BbBtn size="small" type="secondary" :disabled="!sharedLink" @click="copyToClipboard">
        <BbIcon size="small" name="links" />
        <TextBody i18n-key="common.copyLink" />
      </BbBtn>
    </div>
  </BbPopup>
</template>
<script>
import { computed, onMounted, ref } from 'vue';
import { Routes } from '~/constants/routes';
import useCollections from '~/composables/useCollections';
import useModals from '~/composables/useModals';
import validateUrl from '~/utils/url';
import TextBody from '~/components/common/TextBody';

export default {
  components: { TextBody },
  setup() {
    const { setSharedLinkCollectionPopup, sharedLinkCollectionState } = useModals();
    const { getCollection, getSharedCollectionLink } = useCollections();
    const sharedLink = ref('');
    const currentCollection = computed(() => getCollection(sharedLinkCollectionState.value.collectionId).value);
    const isOpened = computed({
      get: () => sharedLinkCollectionState.value.open,
      set: (val) => setSharedLinkCollectionPopup({ open: val, collectionId: {} }),
    });
    const thumbUrl = computed(() => {
      const thumb =
        currentCollection.value.thumbUrl ||
        (currentCollection.value.thumbs.length &&
          currentCollection.value.thumbs[currentCollection.value.thumbs.length - 1].pages[1].small) ||
        '';
      return validateUrl(thumb) ? thumb : '';
    });
    const copyToClipboard = async () => {
      try {
        await navigator.clipboard.writeText(sharedLink.value);
      } catch (err) {
        console.error('Failed to copy:', err);
      }
    };
    onMounted(async () => {
      const sharedLinkId = await getSharedCollectionLink(sharedLinkCollectionState.value.collectionId);
      if (sharedLinkId) {
        sharedLink.value = `${window.location.origin}${Routes.Conversation.pathWithoutParam}/?shareCollection=${sharedLinkId}`;
      }
    });
    return {
      copyToClipboard,
      currentCollection,
      thumbUrl,
      isOpened,
      sharedLink,
      validateUrl,
    };
  },
};
</script>
<style scoped lang="scss">
.shared-collection-header {
  display: flex;

  .collection-details {
    display: flex;
    flex-direction: column;

    .collection-description {
      @include bb-medium-text-styles('xs');
      font-weight: 400;
      color: $bb-neutral-1;
    }

    .collection-title {
      @include bb-medium-text-styles('md');
      line-height: $bb-spacing-5;
    }
  }

  .image-header {
    display: flex;
    align-items: center;
    padding-right: $bb-spacing-3;

    .image-container {
      display: flex;
      flex-direction: column;
      justify-content: space-between; /* Aligns children (start, content, end) */
      border-radius: $bb-spacing-1;
      background-color: $bb-neutral-5;
      min-width: 64px;
      max-width: 64px;
      height: 50px;
      align-items: flex-start;
      gap: $bb-spacing-1;

      .default-thumb {
        width: 64px;
        height: 50px;
        background-color: $bb-neutral-5;
      }

      img {
        max-width: 60px;
        max-height: 48px;
        align-self: center;
      }
    }
  }
}

.share-link-actions {
  display: flex;
  flex-direction: column;
  gap: $bb-spacing-3;
}
</style>
